/**
 * Extracted from sections/ns-reviews-with-filters-v2.liquid (inline <script> at line 185).
 * Config bridge: window.__nsReviewsWithFiltersV2Sections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsReviewsWithFiltersV2Sections = window.__nsReviewsWithFiltersV2Sections || {};
  function boot(nsSectionId, nsSettings) {
    (() => {
      const root = document.getElementById(`shopify-section-${nsSectionId}`);
      if (!root) return;
      const grid = root.querySelector('.ns-rwf2__grid');
      const buttons = Array.from(root.querySelectorAll('.ns-rwf2__filter-btn'));
      const cards = Array.from(root.querySelectorAll('.ns-rwf2__card'));
      const indicator = root.querySelector('.ns-rwf2__filter-indicator');

      const moveIndicator = () => {
        const active = root.querySelector('.ns-rwf2__filter-btn.is-active');
        if (!active || !indicator) return;
        indicator.style.width = active.offsetWidth + 'px';
        indicator.style.transform = 'translateX(' + active.offsetLeft + 'px)';
      };

      const applyCategory = (category) => {
        grid.setAttribute('data-category', category);
        const expanded = root.classList.contains('ns-rwf2--expanded');
        cards.forEach((card) => {
          if (category === 'all') {
            card.hidden = !expanded && !card.classList.contains('is-initial');
          } else {
            card.hidden = card.dataset.category !== category;
          }
        });
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          buttons.forEach((b) => b.classList.remove('is-active'));
          button.classList.add('is-active');
          applyCategory(button.dataset.filter);
          moveIndicator();
        });
      });

      const more = root.querySelector('button.ns-rwf2__more');
      if (more) {
        more.addEventListener('click', () => {
          root.classList.add('ns-rwf2--expanded');
          applyCategory(grid.getAttribute('data-category'));
        });
      }

      window.addEventListener('resize', moveIndicator);
      moveIndicator();
    })();
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
